import { render } from "./estadisticasdia.vue?vue&type=template&id=47c32d9d&lang=es"
import script from "./estadisticasdia.vue?vue&type=script&lang=js"
export * from "./estadisticasdia.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__